import { createActions, createReducer } from 'reduxsauce'

import ExerciciosOperacoesDespesasService from '../servicos/ExerciciosOperacoesDespesasService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaExerciciosOperacoesDespesasInicio: [],
    buscaExerciciosOperacoesDespesasSucesso: ['exercicios', 'jaSelecionado'],
    buscaExerciciosOperacoesDespesasErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaExerciciosOperacoesDespesas = jaSelecionado => {
    return dispatch => {
        dispatch(Creators.buscaExerciciosOperacoesDespesasInicio())
        let serv = new ExerciciosOperacoesDespesasService()
        return serv
            .getExercicios()
            .then(response => dispatch(Creators.buscaExerciciosOperacoesDespesasSucesso(response.data, jaSelecionado)))
            .catch(error => dispatch(Creators.buscaExerciciosOperacoesDespesasErro(error)))
    }
}

const buscaExerciciosOperacoesDespesasInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaExerciciosOperacoesDespesasErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaExerciciosOperacoesDespesasSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.exercicios, carregando: false, selecionado: action.jaSelecionado }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_EXERCICIOS_OPERACOES_DESPESAS_INICIO]: buscaExerciciosOperacoesDespesasInicio,
    [Types.BUSCA_EXERCICIOS_OPERACOES_DESPESAS_ERRO]: buscaExerciciosOperacoesDespesasErro,
    [Types.BUSCA_EXERCICIOS_OPERACOES_DESPESAS_SUCESSO]: buscaExerciciosOperacoesDespesasSucesso,
})
